import React from "react";
import './twitch-chat.css';

const TwitchChat = ({ twitch_channel }) => {
  return (
    <iframe className="twitch-chat" title="chat_embed" src={"https://www.twitch.tv/embed/" + twitch_channel + "/chat?darkpopout&parent=" + window.location.hostname }
      theme= "dark">
    </iframe>
  );
};

export default TwitchChat;
